import React, { useState } from 'react';

import { currentLanguage, useMessages } from '../i18n';
import { postJson } from './api';

const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// Subscribe form in the footer of every page (double opt-in by email).
const NewsletterForm = () => {
  const t = useMessages();
  const [email, setEmail] = useState('');
  const [website, setWebsite] = useState('');
  const [state, setState] = useState('idle'); // idle | sending | sent | invalid | failed

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!EMAIL.test(email.trim())) { setState('invalid'); return; }
    setState('sending');
    const { ok } = await postJson('/newsletter/', { email: email.trim(), language: currentLanguage(), website })
      .catch(() => ({ ok: false }));
    setState(ok ? 'sent' : 'failed');
  };

  if (state === 'sent') {
    return <p className="bm-newsletter__done" role="status">{t.newsletterThanks}</p>;
  }
  return (
    <form className="bm-newsletter" onSubmit={onSubmit} noValidate>
      <label htmlFor="bm-newsletter-email" className="sr-only">{t.emailLabel}</label>
      <div className="bm-newsletter__row">
        <input
          id="bm-newsletter-email"
          type="email"
          autoComplete="email"
          placeholder={t.emailLabel}
          value={email}
          onChange={e => setEmail(e.target.value)}
          aria-invalid={state === 'invalid'}
        />
        <button type="submit" className="btn btn-primary" disabled={state === 'sending'}>{t.subscribe}</button>
      </div>
      <input className="bm-hp" tabIndex={-1} autoComplete="off" aria-hidden="true" value={website} onChange={e => setWebsite(e.target.value)} />
      {state === 'invalid' && <span className="bm-field__error" role="alert">{t.invalidEmail}</span>}
      {state === 'failed' && <span className="bm-field__error" role="alert">{t.newsletterError}</span>}
    </form>
  );
};

export default NewsletterForm;
